class CookiesModalController {
  constructor($rootScope, $uibModalInstance) {
    "ngInject";
    this.$rootScope = $rootScope;
    this.$uibModalInstance = $uibModalInstance;
    this.name = 'cookiesModal';
    this.visible = false;
    this.lang = this.$rootScope.language;
    this.acceptAnalyticsCookies = this.$rootScope.acceptAnalyticsCookies;
    this.acceptMarketingCookies = this.$rootScope.acceptMarketingCookies;
  }

  save() {
    this.$uibModalInstance.close({
      acceptAnalyticsCookies: this.acceptAnalyticsCookies,
      acceptMarketingCookies: this.acceptMarketingCookies
    });
  }

  removeAll() {
    this.$uibModalInstance.close({
      acceptAnalyticsCookies: false,
      acceptMarketingCookies: false
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }
}

export default CookiesModalController;



// WEBPACK FOOTER //
// ./client/app/common/cookiesModal/cookiesModal.controller.js